module.exports = __webpack_public_path__ + "static/media/deactivate.c3ef998b.png";